<template>
  <aside
    class="hidden lg:flex flex-col w-full h-full justify-between bg-gradient-to-t from-[#1e40af] to-[#112360] overflow-hidden relative min-h-[300px] lg:min-h-0"
  >
    <!-- Decorative circle -->
    <img
      :src="rightPanelCircle"
      class="absolute object-cover pointer-events-none w-full h-full"
      alt=""
    />
    <!-- Noise overlay -->
    <div class="noise-overlay" />
    <p
      class="px-8 lg:px-25 py-12 lg:py-7 relative z-10 text-[clamp(25px,1.8vw,40px)] font-medium leading-[1.3] tracking-normal bg-gradient-to-b from-white to-[#687FC9] bg-clip-text text-transparent"
    >
      <span class="block"> Redefining the way healthcare </span>

      <span class="block mt-1 lg:mt-0"> professionals manage clinical literature. </span>
    </p>
    <div class="relative z-10 flex-1 w-full overflow-hidden hidden md:block">
      <img
        :src="macbookMockup"
        class="absolute pointer-events-none w-[150%] md:w-[128%] h-full max-w-none left-4 md:left-10 lg:left-25 object-cover object-left-top"
        alt="Platform preview"
      />
    </div>
  </aside>
</template>

<script lang="ts" setup>
import macbookMockup from "@app/assets/images/login-macbook-mockup.png";
import rightPanelCircle from "@app/assets/images/login-bg-e.png";
</script>

<style scoped>
.noise-overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.07;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.25' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E");
  background-repeat: repeat;
  background-size: 256px 256px;
}
</style>
